import { useState, useEffect, useRef } from "react";
import React from "react";
import { Editor } from "react-draft-wysiwyg";
import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromHTML,
} from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export const ShareActivityTemplate = ({ getContent }) => {
  console.log(shareActivity().toString());
  const [editorState, setEditorState] = useState(() =>
    EditorState.createWithContent(
      ContentState.createFromBlockArray(
        convertFromHTML(shareActivity().toString())
      )
    )
  );

  const handleEditorChange = (state) => {
    setEditorState(state);
  };

  const sendContent = () => {
    // console.log("convertToRaw(editorState.getCurrentContent())", convertToRaw(editorState.getCurrentContent()))
    // getContent(draftToHtml(convertToRaw(editorState.getCurrentContent())));
  };

  const editor = useRef(null);
  const [content, setContent] = useState(shareActivity().toString());
  const config = {
    readonly: false,
    height: 400,
  };

  const handleUpdate = (event) => {
    console.group("", event.target);
    const editorContent = event.target?.innerHTML;
    setContent(editorContent);
  };

  useEffect(() => {
    sendContent();
  }, [editorState]);

  return (
    <div className="w-2/3 h-1/2 p-4">
      <CKEditor
        editor={ClassicEditor}
        data={content}
        onReady={(editor) => {
          // You can store the "editor" and use when it is needed.
          console.log("Editor is ready to use!", editor);
        }}
        onChange={(event, editor) => {
          const data = editor.getData();
          console.log({ event, editor, data });
        }}
        onBlur={(event, editor) => {
          console.log("Blur.", editor);
        }}
        onFocus={(event, editor) => {
          console.log("Focus.", editor);
        }}
      />
      {/* <Editor
        editorState={editorState}
        onEditorStateChange={handleEditorChange}
        wrapperClassName="wrapper-class"
        editorClassName="editor-class"
        toolbarClassName="toolbar-class"
        editorStyle={{ border: "1px solid", height: '10rem' }}
      />
      <JoditEditor ref={editor} value={content} config={config} onBlur={handleUpdate} onChange={(newContent) => {}} /> */}
    </div>
  );
};

const headerName = ["Name", "Email", "Place"];
const values = [
  { name: "Nishikant Sonkusare", email: "sample@mail.com", place: "Nagpur" },
  { name: "Nishikant Sonkusare", email: "sample@mail.com", place: "Nagpur" },
];

export const shareActivity = (
  tablecomponentdata,
  tableData,
  customeFields,
  companyname,
  username,
  teamname,
  tododata
) => {
  let documentBased = [];
  
  if(tododata?.activity?.based_on === "Document" && tododata?.todo_performance_groups?.length > 0){


    if(tododata?.todo_performance_groups[0]?.todo_performances?.length > 0){
      documentBased.push({
        label: tododata?.todo_performance_groups[0]?.todo_performances[0]?.label,
        value: tododata?.todo_performance_groups[0]?.todo_performances[0]?.value
      }, ...tododata?.todo_performance_groups[0]?.todo_performances[0]?.todo_custom_controls || [])
    }
  }

  let value = tododata?.activity?.based_on === "Container" ? "<p>{{Asset Tracking Link}}</p>" : "";

  return `
    <div>
      <p>Dear Sir / Madam,</p>
      <br/>
      ${customeFields
        ?.map((item) => `<p><b>${item.label}</b> : ${item.value}</p>`)
        .join("")}
      ${documentBased?.length > 0 ? `<br/><br/><p><strong>Document Based Data: </strong></p>` : ""}
      <br/>
        ${documentBased
          ?.map((item) => `<p><b>${item.label}</b>: ${item.value}</p>`)
          .join("") + `<br/>`}
      ${value}
      <br />
      <p>Kind regards,</p>
      <p><b>${username}</b></p><br />
      <p>${teamname}</p>
      <p>${companyname}</p>
    </div>
    `;
};
